<template>
    <div
        v-for="(feature, index) in features"
        :key="index"
        class="flex items-center gap-x-1"
    >
        <template v-if="feature.enabled">
            <Icon
                name="circle-check"
                class="w-4 h-4 text-green-600"
            />
        </template>
        <template v-else>
            <Icon
                name="close-circle"
                class="w-4 h-4 text-gray-600"
            />
        </template>
        <span :class="{ 'line-through': !feature.enabled }">
            {{ feature.title }}
        </span>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import type { PlanFeatureDisplayType } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        features: {
            type: Array as PropType<PlanFeatureDisplayType[]>,
            required: true,
        },
    })
</script>
